'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/mcs-client/node_modules/core-js/internals/path.js
// module id = 5986
// module chunks = 25